import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllKodePayDropdownPraktikum = createAsyncThunk(
  "kodePay/GetAllKodePayDropdownPraktikum",
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kode_payment/praktikum`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllKodePayDropdownAdmin = createAsyncThunk(
  "kodePay/GetAllKodePayDropdownAdmin",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kode_payment/admin${data.query}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllKodePayDropdown = createAsyncThunk(
  "kodePay/GetAllKodePayDropdown",
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kode_payment`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllKodepayVA = createAsyncThunk(
  "kodepayVA/GetAllKodepayVA",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kode_payment/all?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllKodepayVAByPeriod = createAsyncThunk(
  "kodepayVA/GetAllKodepayVAByPeriod",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kode_payment/get_by_period?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleKodepayVA = createAsyncThunk(
  "kodepayVA/GetSingleKodepayVA",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kode_payment/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const kodepayVASlice = createSlice({
  name: "kodepayVA",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all kodepayVA for dropdown praktikum
    builder.addCase(GetAllKodePayDropdownPraktikum.pending, loadingHandler);
    builder.addCase(GetAllKodePayDropdownPraktikum.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodePayDropdownPraktikum.rejected, rejectedHandler);
    // get all kodepayVA for dropdown
    builder.addCase(GetAllKodePayDropdown.pending, loadingHandler);
    builder.addCase(GetAllKodePayDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodePayDropdown.rejected, rejectedHandler);
    // get all kodepayVA for dropdown admin
    builder.addCase(GetAllKodePayDropdownAdmin.pending, loadingHandler);
    builder.addCase(GetAllKodePayDropdownAdmin.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodePayDropdownAdmin.rejected, rejectedHandler);
    // get all kodepayVA
    builder.addCase(GetAllKodepayVA.pending, loadingHandler);
    builder.addCase(GetAllKodepayVA.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodepayVA.rejected, rejectedHandler);
    // get all kodepayVA by period
    builder.addCase(GetAllKodepayVAByPeriod.pending, loadingHandler);
    builder.addCase(GetAllKodepayVAByPeriod.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodepayVAByPeriod.rejected, rejectedHandler);
    // get single kodepayVA
    builder.addCase(GetSingleKodepayVA.pending, loadingHandler);
    builder.addCase(GetSingleKodepayVA.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleKodepayVA.rejected, rejectedHandler);
  },
});

export const { reset } = kodepayVASlice.actions;
export default kodepayVASlice.reducer;
